import { defaultZodCatch } from '@/lib/converters/defaultZodCatch'
import { zAllFavoriteListIdsByProductsResponse } from '@/schemas/allFavoriteListIdsByProductsSchema'

import type { FavoriteListIdsResponseDto } from '@/gen/bff'
import type { AllFavoriteListIdsByProducts } from '@/schemas/allFavoriteListIdsByProductsSchema'

export const getAllFavoriteListIdsByProductsConverter = (
  data: FavoriteListIdsResponseDto[]
): AllFavoriteListIdsByProducts[] => {
  if (!Array.isArray(data)) {
    return []
  }

  return data.map((item: FavoriteListIdsResponseDto) => {
    const response = {
      productIds: item.productIds ?? undefined,
      favoriteListIds: item.favoriteListIds ?? undefined,
    }

    return zAllFavoriteListIdsByProductsResponse.catch(defaultZodCatch).parse(response)
  })
}
